export const it = {
  utilityModule: {
    groups: {
      warehouse: "Magazzino",
    },
  },
};
